import React, { useState } from "react";
import { useFormContext, useFieldArray } from "react-hook-form";
import { Button } from "antd";
import Select from "react-select";
import { Delete, PlusCircle, Trash2 } from "react-feather";
import { format } from "date-fns";
import Input from "Components/UI/Input";
import dayjs from "dayjs";
import ImageUploader from "Components/UI/ImageUploder";
import { useGetDormitorysQuery } from "AppQuries/master/dormitory";
const activestatus = [
  { id: true, label: "Yes", value: true },
  { id: false, label: "No", value: false },
];

const AccommondationDetails = () => {
  const {
    control,
    register,
    setValue,
    getValues,
    watch,
    formState: { errors },
    trigger,
  } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "accommodationDetail",
  });

  const { data: dormitory } = useGetDormitorysQuery({
    companyCode: watch("companyCode"),
    isTrue: true,
  });

  const dormitoryOptions = Array.isArray(dormitory)
    ? dormitory
        .filter((o) => o.isActive === true)
        .map((o) => ({
          id: o.dormitoryCode,
          label: o.dormitoryName,
          value: o.dormitoryCode,
        }))
    : [];

  const accommodationDetails = watch("accommodationDetail") || [];

  const addAccommodationDetailsRow = () => {
    const NewAccommodationDetails = {
      companyCode: watch("companyCode"),
      accommodationCode: 0,
      employeeCode: watch("employeeCode"),
      accommodationName: "",
      room: "",
      bed: "",
      startDate: "",
      endDate: "",
      isActive: true,
      createUser: watch("createUser"),
      modifyUser: watch("modifyUser"),
      createDate: watch("createDate"),
      modifyDate: watch("modifyDate"),
    };

    setValue("accommodationDetail", [
      ...accommodationDetails,
      NewAccommodationDetails,
    ]);
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 16,
        }}
      >
        <h4></h4>
        <button
          className="btn btn-secondary btn-sm "
          type="button"
          onClick={addAccommodationDetailsRow}
        >
          <PlusCircle className="me-2" />
          Add Row
        </button>
      </div>
      <div className="table-responsive" style={{ minHeight: "250px" }}>
        <table className="table custom-table table-nowrap mb-0">
          <thead>
            <tr>
              <th>-</th>
              <th>Dormitory</th>
              <th>Accommodation Name</th>
              <th>Room</th>
              <th>Bed</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {accommodationDetails.map((data, index) => {
              return (
                <tr key={index}>
                  <td>
                    <Button type="danger" onClick={() => remove(index)}>
                      <Trash2 />
                    </Button>
                  </td>
                  <td>
                    <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
                      <Input
                        name={`accommodationDetail[${index}].dormitoryCode`}
                        type="commonSelect"
                        placeholder=""
                        className={`form-control ${
                          errors.dormitoryCode ? " is-invalid" : ""
                        }`}
                        label=""
                        labelClassName="form-label"
                        optionData={dormitoryOptions}
                        required={false}
                        requiredMessage="Dormitory Type is required"
                        onChange={(selectedOption) => {
                          setValue(
                            `accommodationDetail[${index}].dormitoryCode`,
                            selectedOption
                          );
                          trigger(
                            `accommodationDetail[${index}].dormitoryCode`
                          );
                        }}
                        style={{ width: "200px" }}
                        defaultValue={watch(
                          `accommodationDetail[${index}].dormitoryCode`
                        )}
                      />
                    </div>
                  </td>
                  <td>
                    <Input
                      name={`accommodationDetail[${index}].accommodationName`}
                      type="text"
                      placeholder="Accommodation Name"
                      className={`form-control ${
                        errors?.accommodationDetail?.[index]?.accommodationName
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>
                  <td>
                    <Input
                      name={`accommodationDetail[${index}].room`}
                      type="text"
                      placeholder="Room"
                      className={`form-control ${
                        errors?.accommodationDetail?.[index]?.room
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "100px" }}
                    />
                  </td>
                  <td>
                    <Input
                      name={`accommodationDetail[${index}].bed`}
                      type="text"
                      placeholder="Bed"
                      className={`form-control ${
                        errors?.accommodationDetail?.[index]?.bed
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "100px" }}
                    />
                  </td>

                  <td>
                    <Input
                      name={`accommodationDetail[${index}].startDate`}
                      type="date"
                      placeholder="Start Date"
                      className={`form-control ${
                        errors?.accommodationDetail?.[index]?.startDate
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      defaultValue={
                        dayjs(
                          watch(`accommodationDetail[${index}].startDate`),
                          "YYYY-MM-DD"
                        ) || ""
                      }
                      dateFormat="YYYY-MM-DD"
                      style={{ width: "150px" }}
                    />
                  </td>
                  <td>
                    <Input
                      name={`accommodationDetail[${index}].endDate`}
                      type="date"
                      placeholder="End Date"
                      className={`form-control ${
                        errors?.accommodationDetail?.[index]?.endDate
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      defaultValue={
                        dayjs(
                          watch(`accommodationDetail[${index}].endDate`),
                          "YYYY-MM-DD"
                        ) || ""
                      }
                      dateFormat="YYYY-MM-DD"
                      style={{ width: "150px" }}
                    />
                  </td>

                  <td>
                    <Input
                      name={`accommodationDetail[${index}].isActive`}
                      type="commonSelect"
                      placeholder=""
                      className={`form-control ${
                        errors.accommodationDetail?.[index]?.isActive
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName="form-label"
                      optionData={activestatus}
                      required={true}
                      requiredMessage="Active Status is required"
                      onChange={(selectedOption) => {
                        setValue(
                          "accommodationDetail[${index}].isActive",
                          selectedOption
                        );
                        trigger("accommodationDetail[${index}].isActive");
                      }}
                      defaultValue={watch(
                        "accommodationDetail[${index}].isActive"
                      )}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AccommondationDetails;
